import gql from 'graphql-tag';

export const FOOTER_QUERY = gql`
  query FooterNavs {
    footer {
      link {
        label
        url
        alt
      }
      logo {
        URL
        media {
          alternativeText
          url
          webPURL
        }
      }
      copyrightText1
      copyrightText2
    }
  }
`;

export default FOOTER_QUERY;
